export const SUPPORTED_LOCALES = [
  'en',
  'zh',
  'hi',
  'es',
  'ar',
  'fr',
  'bn',
  'pt',
  'ru',
  'ur',
  'de',
  'fa',
  'it',
] as const;

export type SupportedLocaleType = (typeof SUPPORTED_LOCALES)[number];
